import { defineComponent, onMounted, onUnmounted } from 'vue';
import ResetEnrolmentsConfirmationModalComponent
	from '@/presentation/components/internal/reset-enrolments-confirmation-modal/reset-enrolments-confirmation-modal-class';

export default defineComponent({
	setup: () => {
		const component = new ResetEnrolmentsConfirmationModalComponent();

		onMounted(component.mounted.bind(component));
		onUnmounted(component.unmounted.bind(component));

		return {
			modalContent: component.modalContent,
			selectedEnrolmentsCount: component.selectedEnrolmentsCount,
			confirm: component.confirm.bind(component),
			dismiss: component.dismiss.bind(component)
		};
	}
});
